import * as React from "react";
import { toast } from "react-toastify";
const Loader = require("react-loader-spinner").default;
import * as Modal from "react-modal";
import "./Users.css";
import Header from "./Header"
export default class Users extends React.Component<any, any> {
  viewsSales: any;
  productsSales: any;
  usersSales: any;
  searchInput: any;
  constructor(props: any) {
    super(props);
    this.state = {
      modalOpen: false,
      campaign: null,
      foundUsers: [],
      users: [],
      loading: false,
      timeoutId: null
    };
  }

  loadCampaign = () => {
    fetch(`campaigns/get`, {
      method: "POST",
      body: JSON.stringify({id: this.props.match.params.id})
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ campaign: data.campaign });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };


  loadUsers = () => {
    fetch(`campaigns/getUsers`, {
      method: "POST",
      body: JSON.stringify({id: this.props.match.params.id})
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ users: data.users });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };




  componentDidMount() {
    this.loadCampaign();
    this.loadUsers();
  }


  search = (e: any) => {
    if (e.keyCode === 13) {
      if (this.searchInput?.length > 1) {
        fetch("users/search", {
          method: "POST",
          body: JSON.stringify({
            search: this.searchInput,
            international: false,
          }),
        })
          .then((results) => {
            return results.json();
          })
          .then((data) => {
            let foundUsers = data.users.map((user:any) => {
              const found = this.state.users.find((u:any) => {
                if(u.id === user.id) return true;
                return false;
              })
              if(found) user.added = true;
              return user;
            })
            this.setState({ foundUsers, loading: false });
          })
          .catch((err) => {
            this.setState({ loading: false });
            toast.error(err.message);
          });
      }
    } else {
      this.searchInput = e.target.value;
    }
  };


  addUser = (user:any) => {
    const users = this.state.users
    fetch(`campaigns/addUser`, {
      method: "POST",
      body: JSON.stringify({id: this.props.match.params.id ,userId: user.id})
    })
      .then((results) => {
        return results.json();
      })
      .then(() => {
        const foundUsers = this.state.foundUsers.map((u:any) => {
          if(u.id === user.id) u.added = true;
          return u;
        })
        users.push(user)
        this.setState({users, foundUsers})
      })
      .catch((err) => {
        //toast.error(err.message);
      });

  }


  removeUser = (user: any, i:number) => {
    const users = this.state.users
    fetch(`campaigns/removeUser`, {
      method: "POST",
      body: JSON.stringify({id: this.props.match.params.id ,userId: user.id})
    })
      .then((results) => {
        return results.json();
      })
      .then(() => {
        const foundUsers = this.state.foundUsers.map((u:any) => {
          if(u.id === user.id) u.added = false;
          return u;
        })
        users.splice(i, 1)
        this.setState({users, foundUsers})
      })
      .catch((err) => {
        //toast.error(err.message);
      });

  }


  editUser = (index:number, e:any) => {
    clearTimeout(this.state.timeoutId);
    const users = this.state.users
    users[index][e.target.name] = e.target.value
    const user = users[index];
    this.setState({
      users,
      timeoutId: setTimeout(() => {
        // Send request to the server to save the input
        fetch(`campaigns/editUser`, {
          method: "POST",
          body: JSON.stringify({
            id: user.userCampaignId,
            campaignId: this.props.match.params.id,
            userId: user?.id,
            fee: user?.fee,
            coupon: user?.coupon
          })
        })
          .catch((err) => {
            //toast.error(err.message);
          });

      }, 500),
    });
  };





  public render() {
    const {campaign} = this.state
    return (
        <div id="users-root">
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <Header campaign={campaign} activeTab={"users"} openMenu={this.props.openMenu} />
        <Modal isOpen={this.state.modalOpen} className="searchUser-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                modalOpen: false
              });
            }}
          ></a>
          <input
            name="title"
            type="text"
            placeholder={"חיפוש משפיען"}
            onKeyDown={(e) => {
              this.search(e);
            }}
          />
          <ul>
            {this.state.foundUsers.map((user:any) => {
              return <li>{!user.added && <i className="fas fa-plus" onClick={() => {
                this.addUser(user)
              }}></i>}
              
              {user.name}
              </li>
            })}
          </ul>
        </Modal>

        {window.account.type !== "user" && <button onClick={() => {
          this.setState({modalOpen: true})
        }} className="primary-btn">
            הוספת משפיען לקמפיין
        </button>}
        {this.state.users.map((user:any, i:number) => {
          return (
            <div className="user-row white-box">
                  {user.type === "instagram" && (
                    <i className="fab fa-instagram"></i>
                  )}
                  {user.type === "facebook" && (
                    <i className="fab fa-facebook"></i>
                  )}
                  <div className="info">
                    <label>שם</label>
                    <span>{user.name}</span>
                  </div>
                  <div className="info">
                    <label>עוקבים</label>
                    <span>{user.followers || 0}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>קוד קופון</label>
                    <input name="coupon" onChange={(e) => {this.editUser(i, e)}} value={user.coupon || "אין"} />
                  </div>
                  <div className="info">
                    <label>עמלה ₪</label>
                    <input name="payment" onChange={(e) => {this.editUser(i, e)}} value={user.fee || 0} />
                  </div>
                  <div className="info">
                    <label>צפיות</label>
                    <span>{user.views || 0}</span>
                  </div>
                  <div className="info">
                    <label>מכירות</label>
                    <span>₪{user.sales || 0}</span>
                  </div>
                  <div className="info no-after">
                    <label>סה״כ</label>
                    <span>₪{user.payment && user.clicks? user.fee/100 *  user.sales : 0}</span>
                  </div>
                  <div className="settings info">
                    <label>הגדרות</label>
                    <a href={`/campaigns/${campaign?.id}/users/${user?.id}`}><i
                      className="fas fa-user"
                    ></i></a>
                    <i style={{cursor:"pointer"}}
                      onClick={() => {
                        navigator.clipboard.writeText(`${campaign?.url}?coupon=${user.coupon}`).then(function() {
                          toast.success("לינק קמפיין הועתק")
          
                      }, function(err) {
                          console.error('Async: Could not copy text: ', err);
                        });

                      }}
                      className="fas fa-link"
                    ></i>
                    <i
                      style={{cursor:"pointer"}}
                      onClick={() => {
                        this.removeUser(user, i);
                      }}
                      className="fas fa-trash-alt"
                    ></i>
                  </div>
            </div>
          )
        })}

        </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaign/Users.tsx